import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { limitStr } from "utils/utils";
import styles from "./FoodCourtItem.module.css";
import placeholder360x225 from "assets/placeholder/360x225.png";
import { promotionTypes } from "config/promotionTypes";
import phoneWhite from "assets/images/icon-phone-white.svg";
import playClickSpecial from "utils/playClickSpecial";

const FoodCourtItem = ({ listItem }) => {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/+$/, "");
  const langState = useSelector((state) => state.language.lang);

  return (
    <div
      className={styles.foodcourt_item}
      key={`${listItem.id}-${listItem.code}`}
    >
      <div className={styles.wrapp_title}>
        <h4 className={styles.title}>{limitStr(listItem.title)}</h4>
        <div className={styles.phone_number}>
          <img
            src={phoneWhite}
            className={styles.phone_image}
            alt={listItem.title}
          />
          {listItem.phone}
          {listItem.promotion_tag && listItem.promotion_tag != 0 && (
            <img
              src={promotionTypes[langState][listItem.promotion_tag]}
              alt="promotion"
              className={`${styles.promotion}  ${
                listItem.promotion_tag === "new" ? styles.new : ""
              }`}
            />
          )}
        </div>
      </div>
      <div className={styles.wrapp_image}>
        <Link
          to={{
            pathname: `${pathname}/${listItem.id}`,
            search: `?code=${listItem.code}`,
          }}
          onClick={playClickSpecial}
        >
          <img
            src={listItem.thumb || placeholder360x225}
            alt={listItem.title}
          />
        </Link>
      </div>
    </div>
  );
};

export default FoodCourtItem;
